import { ACTION_METHODS, METRIC_TYPE, SITE_SERVICES } from 'src/katalMetrics/metricsModels';
import { captureMetrics } from 'src/katalMetrics/metricsHelperMethods';

/**
 * Publish a Katal metric for an action taken under a limited-edit app role
 * (see APP_EDIT_ROLES). Only the role id is published -- never app data or aliases.
 * No-op when there is no role, so full editors are not double counted here.
 */
export const captureAppEditRoleMetric = (actionMethod, role, metricName) => {
  if (!role || !actionMethod || !metricName) return null
  return captureMetrics(actionMethod, [{
    metricName,
    metricValue: role.id,
    metricType: METRIC_TYPE.STRING,
    isMonitor: false
  }], SITE_SERVICES.ACCOUNTING_CENTRAL_APP)
}
